import React from 'react'

const Chapter03 = () => {
    return (
        <div>
            <h3 className='title'>Capítulo 03</h3>
            <div className='description'>No entanto, sua maior aventura ainda estava por vir. Quando uma antiga profecia ameaçou mergulhar o reino nas trevas, Sir Eliot aceitou o desafio de sua vida. Com seu fiel cavalo, Tempestade, ao seu lado, e guiado por seu inabalável senso de dever, Sir Eliot partiu em uma jornada que testaria sua coragem e revelaria segredos além de sua imaginação.</div>

        </div>
    )
}

export default Chapter03